import type { SiteUrls } from './types';

export const SITE_URLS: SiteUrls = {
  base_url: 'https://www.assessfirst.com',
  cookies: {
    fr: 'cookies',
    de: 'cookies',
    es: 'cookies',
    en: 'cookies',
    ru: 'файлы-cookie',
    pt: 'cookies',
  },
  privacy: {
    fr: 'politique-relative-aux-donnees-a-caractere-personnel',
    de: 'datenschutz',
    es: 'politica-de-privacidad',
    en: 'privacy-policy',
    ru: 'политика-конфиденциальности',
    pt: 'politica-de-privacidade',
  },
  terms_of_use: {
    fr: 'conditions-generales-utilisation',
    de: 'nutzungsbedingungen',
    es: 'condiciones-de-uso',
    en: 'terms-of-use',
    ru: 'условия-использования',
    pt: 'termos-de-uso',
  },
  terms_of_sales: {
    fr: 'conditions-generales-vente',
    de: 'verkaufsbedingungen',
    es: 'condiciones-de-servicio',
    en: 'terms-and-conditions-of-sale',
    ru: 'условия-обслуживания',
    pt: 'termos-do-servico',
  },
};
